import { DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import scheduledDowntimeIcon from 'assets/dashboard/scheduledDowntime.png';
import DowntimeManagementUpiDashboard from './upi';

export const DOWNTIMEMANAGEMENT_RESOURCES = {
	upi: 'upi'
};

export const URL = {
	[DOWNTIMEMANAGEMENT_RESOURCES.upi]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/downtimemanagement/${DOWNTIMEMANAGEMENT_RESOURCES.upi}`
};

export const LABEL = {
	[DOWNTIMEMANAGEMENT_RESOURCES.upi]: 'UPI'
};

export const COMPONENT = {
	[DOWNTIMEMANAGEMENT_RESOURCES.upi]: DowntimeManagementUpiDashboard
};

export const GET_ACTION = {
	[DOWNTIMEMANAGEMENT_RESOURCES.upi]: 'getUPIDowntimeManagementPage'
};

export const IMAGE_SOURCE = {
	[DOWNTIMEMANAGEMENT_RESOURCES.upi]: scheduledDowntimeIcon
};

export type Record = {
	[key: string]: string | number | boolean;
};

export type SelectedUserType = {
	email: string;
	uid: string;
	phone: string;
	userSegment: string;
	addToStatic: boolean;
};
